<template>
    <div class="app-confirm-birthdate">
      <slot name="txtBefore">
        <p>
          Zur Bestätigung Ihrer E-Mail-Adresse geben Sie bitte noch Ihr Geburtsdatum an und klicken Sie dann auf absenden
        </p>
      </slot>
      <b-form
        :id="'form' + _uid"
        :novalidate="true"
        data-confirm-birthdate
      >
        <b-form-group class="birthdate-group">
          <b-form-row>
            <label class="mandatory">
              <slot name="lblBirthdate">Geburtsdatum</slot>
            </label>
            <b-input-group>
              <b-form-input
                :id="'birthdate' + _uid"
                v-model="birthdate"
                type="text"
                name="birthdate"
                required
                :state="isValid('birthdate')"
                @input="$v.birthdate.$touch"
                placeholder="TT.MM.JJJJ"
                autocomplete="off"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  v-bind="calendarSettings || {}"
                  button-only
                  right
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  @input="$v.birthdate.$touch"
                  @context="selectDate"
                  :aria-controls="'birthdate' + _uid"
                ></b-form-datepicker>
              </b-input-group-append>
              <b-form-invalid-feedback>
                <slot name="errorMessageBirthdate">Bitte geben Sie Ihren Geburtstag an</slot>
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-row>
        </b-form-group>
        <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
          <b-button class="btn-next" type="button" variant="primary" :disabled="$v.$invalid || loading" v-on:click="next">
            <slot name="btnNext">absenden</slot>
          </b-button>
        </b-overlay>
      </b-form>
    </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { validDate, validDateFormat } from '../../../../../validators/date'
import { mapActions } from 'vuex'
import isValid from '../../../../../mixins/isValid'

export default {
  name: 'ConfirmBirthdate',
  data () {
    return {
      birthdate: null,
      loading: false
    }
  },
  computed: {
    calendarSettings () {
      return this.$config.calendar.calendarSettings
    }
  },
  mixins: [validationMixin, isValid],
  methods: {
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.birthdate = ctx.selectedFormatted
      }
    },
    ...mapActions('emailConfirmation', [
      'confirmBirthdate'
    ]),
    async next () {
      this.loading = true
      await this.confirmBirthdate({ birthdate: this.birthdate })
      this.loading = false
    }
  },
  validations () {
    return {
      birthdate: {
        required,
        validDate,
        validDateFormat
      }
    }
  }
}
</script>
